import { Navigate } from "react-router-dom";
export default function AdminIndex() { return <Navigate to="/redaction/dashboard" replace />; }
